export default __webpack_public_path__ + "static/media/slide_2.8f7043a4.jpg";